export const inputChangeHandler = (
  e: React.ChangeEvent<HTMLInputElement>,
  setState: any
) => {
  setState((prevState: any) => {
    return { ...prevState, [e.target.name]: e.target.value };
  });
};
